// Elenco delle news
var React = require('react');
import PropTypes from 'prop-types';
import {get} from './Storage';
import Mission from './Mission'

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGMissionsListComponent';

class MissionsList extends React.Component{    

    constructor(props) {
        super(props);
    }

    render() {
        var missionsNodes = "";
        if (this.props.data.length > 0) {
            missionsNodes = this.props.data.map(function (mission, i) {
                return (
                     <Mission key={mission.Id} mission={mission}/>                    
                )
            }.bind(this));
         }else{
            missionsNodes = <div className="no-list">Non stai partecipando a nessuna missione</div>;
         }
        return (
             <>
                 {missionsNodes}
             </> 
        );
    };
};
MissionsList.displayName = componentName;
// PropTypes validation
MissionsList.propTypes = {
    data: PropTypes.array.isRequired
};

// default props
MissionsList.defaultProps = {
    data: []
};
export default MissionsList;